var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header-component'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }